import React, {Component} from 'react';
import * as Sentry from '@sentry/browser';
import LogRocket from 'logrocket';
import RouteRoot from "./RouteRoot";
import auth from "./data/auth";
import './App.css';
import ToastRx from "./components/extras/ToastRx";
import ErrorBoundary from "./components/extras/ErrorBoundary";
import AlertRx from "./components/extras/AlertRx";
import localDB from "./data/localDB";
import LocalData from "./data/LocalData";
import QuestionDialogRx from "./components/extras/QuestionDialogRx";
import globals from "./data/globals";

class App extends Component {

    constructor() {
        super();
        this.state = {
            loading: true
        };

        if(!globals.DEBUG && !globals.LOCAL_DEBUG){
            LogRocket.init('7ovrjz/bisttros', {
                dom: {
                  textSanitizer: false,
                  inputSanitizer: false,
                },
            });
            
            Sentry.init({
                dsn: 'https://dd8fdb714c3845529e49eceb0d713940@o95808.ingest.sentry.io/218006',
                beforeSend(event) {
                    if(typeof(event.user) === 'object'){
                        event.user = localDB.getUser();
                        event.user.session = localDB.getAuthToken();
                        event.user.version = '1.0.91'
                    }
                    const logRocketSession = LogRocket.sessionURL;
                    if (logRocketSession !== null) {
                        event.extra["LogRocket"] = logRocketSession;
                    }
                    return event;
                },
                ignoreErrors:[
                    'ResizeObserver loop limit exceeded',
                    'Access is denied.',
                    "Can't execute code from a freed script"
                ]
            });
            if(localDB.getUser()){
                Sentry.setUser({ id: localDB.getUser().email });
                LogRocket.identify(localDB.getUser().id, {
                    name: localDB.getUser().full_name,
                    email: localDB.getUser().email
                  });

                document.tidioIdentify = {
                    distinct_id: localDB.getUser().id,
                    email: localDB.getUser().email,
                    name: localDB.getUser().full_name
                };

                (function() {
                    function onTidioChatApiReady() {
                        window.tidioChatApi.setVisitorData({
                            email: localDB.getUser().email,
                            tags: [`store__${localDB.getUser().store}`, `branch_office__${localDB.getUser().branch_office}`]
                        });
                    }
                    if (window.tidioChatApi) {
                        window.tidioChatApi.on("ready", onTidioChatApiReady);

                    } else {
                        document.addEventListener("tidioChat-ready", onTidioChatApiReady);
                    }
                })();



                // tidioChatApi.addVisitorTags(["tag1", "tag2"]);
            }

            Sentry.configureScope(scope => {
                scope.setExtra("sessionURL", LogRocket.sessionURL);
            });

            LogRocket.getSessionURL(sessionURL => {
                Sentry.configureScope(scope => {
                    scope.setExtra("sessionURL", sessionURL);
                });
            });
        }
    };

    render() {
        return (
            this.state.loading ? null:
                <ErrorBoundary>
                    <div>
                        <RouteRoot/>
                        <ToastRx />
                        <AlertRx />
                        <QuestionDialogRx />
                    </div>
                </ErrorBoundary>
        );
    };

    async componentDidMount(){
        await this.initialFetch();
    };

    async initialFetch() {
        try{
            auth.refresh().then(res =>{
                localDB.initialData(res);
                LocalData.products();
                LocalData.clients();
                LocalData.providers();
                LocalData.ingredients();
            }).catch(()=>{
                localDB.cleanSession();
            }).finally(() =>{
                setTimeout(()=>{
                    const ele = document.getElementById('ipl-progress-indicator');
                    ele.parentNode.removeChild(ele);
                    this.setState({loading:false});
                }, 1000);
            });
        }catch (e) {
            this.setState({loading:false});
            localDB.cleanSession();
        }
    };
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js